import { useDispatch } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./ActivityDialog.css";
import "../Components/Components.css";
import { ReactComponent as LiveChatOngoingIcon } from "../Images/LiveChatOngoing.svg";
import { SET_SELECTED_CALL_RECORD_ID } from "../Store/Types/CallTypes";

const ActivityDialog = ({
  changePage,
  data,
  isOpen,
  selectedActivity,
  setIsActivityDialogShown,
}) => {
  const dispatch = useDispatch();

  const columnsCall = [
    {
      field: "ContactID",
      flex: 1,
      headerName: "Contact ID",
    },

    {
      field: "ContactName",
      flex: 1,
      headerName: "Contact Name",
    },

    {
      field: "PhoneNo",
      flex: 1,
      headerName: "Phone Number",
    },

    {
      field: "ConnectTime",
      flex: 1,
      headerName: "Connected Time",

      renderCell: (params) =>
        params.row.ConnectTime
          ? moment(params.row.ConnectTime).format("DD-MMM-yyyy HH:mm:ss")
          : "",
    },

    {
      field: "DisconnectTime",
      flex: 1,
      headerName: "Disconnected Time",

      renderCell: (params) =>
        params.row.DisconnectTime
          ? moment(params.row.DisconnectTime).format("DD-MMM-yyyy HH:mm:ss")
          : "",
    },

    {
      field: "TalkDuration",
      flex: 1,
      headerName: "Duration",

      renderCell: (params) =>
        moment
          .utc(
            moment.duration(params.row.TalkDuration, "seconds").asMilliseconds()
          )
          .format("HH:mm:ss"),
    },

    {
      field: "CallType",
      flex: 1,
      headerName: "Call Type",
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "By Agent",
    },

    {
      field: "action",
      flex: 0.5,
      headerName: "Action",

      renderCell: () => {
        return (
          <IconButton
            onClick={() => {
              // TODO: Still hardcoded, need to get call log record ID
              dispatch({ type: SET_SELECTED_CALL_RECORD_ID, payload: 1619 });
              changePage("callHistory");
            }}
          >
            <Icon
              color="#7e7e7e"
              height="26"
              icon="ic:baseline-remove-red-eye"
            />
          </IconButton>
        );
      },
    },
  ];

  const columnsChat = [
    {
      field: "ContactID",
      flex: 1,
      headerName: "Contact ID",
    },

    {
      field: "ContactName",
      flex: 1,
      headerName: "Contact Name",
    },

    {
      field: "ReceiveTime",
      flex: 1,
      headerName: "Receive Time",

      renderCell: (params) =>
        params.row.ConnectTime
          ? moment(params.row.ConnectTime).format("DD-MMM-yyyy HH:mm:ss")
          : "",
    },

    {
      field: "Source",
      flex: 0.8,
      headerName: "Chat Source",

      renderCell: (params) => {
        let icon;

        switch (params.row.Source) {
          case 1:
            icon = "ic:baseline-local-phone";
            break;

          case 2:
            icon = "material-symbols:mail-outline";
            break;

          case 5:
            break; // Special case, uses custom icon

          case "Whatsapp":
            icon = "ic:baseline-whatsapp";
            break;

          default:
            icon = "ic:baseline-whatsapp";
            break;
        }

        return <Icon color="#7e7e7e" height="26" icon={icon} />;
      },
    },

    {
      field: "Status",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "MobileNo",
      flex: 1,
      headerName: "Mobile No",
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "action",
      flex: 0.5,
      headerName: "Action",

      renderCell: () => {
        return (
          <IconButton
            onClick={() => {
              // TODO: need to get chat ID
              changePage("chat");
            }}
          >
            <Icon
              color="#7e7e7e"
              height="26"
              icon="ic:baseline-remove-red-eye"
            />
          </IconButton>
        );
      },
    },
  ];

  const columnsTicket = [
    {
      field: "TicketNo",
      flex: 1.4,
      headerName: "Ticket No",
    },

    {
      field: "Title",
      flex: 1.2,
      headerName: "Title",
    },

    {
      field: "CustomerName",
      flex: 1,
      headerName: "Customer",
      minWidth: 95,
    },

    {
      field: "Types",
      flex: 1,
      headerName: "Type",
    },

    {
      field: "SubType",
      flex: 1.4,
      headerName: "Sub Type",
    },

    {
      align: "center",
      field: "ContactHelpdesk",
      flex: 0.8,
      headerName: "Channel",
      minWidth: 85,

      renderCell: (params) => {
        let icon;

        switch (params.row.ContactID) {
          case 1:
            icon = "ic:baseline-local-phone";
            break;

          case 2:
            icon = "material-symbols:mail-outline";
            break;

          case 5:
            break; // Special case, uses custom icon

          case 9:
            icon = "ic:baseline-whatsapp";
            break;

          default:
            break;
        }

        return params.row.ContactID === 5 ? (
          <LiveChatOngoingIcon fill="#7e7e7e" height="32" width="32" />
        ) : (
          <Icon color="#7e7e7e" height="26" icon={icon} width="26" />
        );
      },
    },

    {
      field: "CreateUserBy",
      flex: 1,
      headerName: "Created By",
    },

    {
      field: "CreatedDate",
      flex: 1,
      headerName: "Created Date",
      renderCell: (params) =>
        moment.utc(params.row.CreatedDate).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "AssignedTo",
      flex: 1,
      headerName: "Assigned To",
      minWidth: 90,
    },

    {
      field: "LastUpdateUser",
      flex: 1,
      headerName: "Last Update By",
    },

    {
      field: "LastUpdateDate",
      flex: 1,
      headerName: "Last Update Date",
      renderCell: (params) =>
        moment.utc(params.row.LastUpdateDate).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "Status",
      flex: 1,
      headerName: "Status",
      minWidth: 85,
    },

    {
      field: "Department",
      flex: 1,
      headerName: "Department",
      minWidth: 120,
    },

    {
      flex: 0.8,
      headerName: "Action",

      renderCell: () => {
        return (
          // TODO: Need case ID
          <IconButton onClick={() => changePage("ticket")}>
            <Icon
              color="#7e7e7e"
              height="26"
              icon="ic:baseline-remove-red-eye"
              width="26"
            />
          </IconButton>
        );
      },
    },
  ];

  const handleClose = () => {
    setIsActivityDialogShown(false);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog activity-dialog"
      fullWidth
      maxWidth="xxl"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          <h2 className="title">Activity</h2>

          <div className="table-container">
            <DataGrid
              // autoHeight
              className="table"
              columns={
                selectedActivity === "call"
                  ? columnsCall
                  : selectedActivity === "chat"
                  ? columnsChat
                  : selectedActivity === "ticket"
                  ? columnsTicket
                  : null
              }
              disableColumnFilter
              disableColumnMenu
              disableSelectionOnClick
              // loading={isLoading}
              rows={data}
              getRowId={(row) =>
                selectedActivity === "call"
                  ? row.PhoneNo +
                    "-" +
                    row.ConnectTime +
                    "-" +
                    row.DisconnectTime
                  : selectedActivity === "chat"
                  ? row.ReceiveTime + "-" + row.MobileNo
                  : selectedActivity === "ticket"
                  ? row.TicketNo
                  : null
              }
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ActivityDialog;
